import { map as _map } from 'lodash';
import { find as _find } from 'lodash';

class VehiclePricingController {
  constructor(lookupService, authService, priceManagementService, $scope) {
    "ngInject";

    this.lookupService = lookupService;
    this.authService = authService;
    this.priceManagementService = priceManagementService;
    this.$scope = $scope;

    this.$scope.$on('vehicle:initialized',() => {setTimeout(this.vehicleInitialized.bind(this), 500)});

    this.initializeLookups();
    this.initializeEntityPriceFormula();

    this.panels = {
      priceFields: true
    }

    this.editLoad = false;
  }

  vehicleInitialized(){
    const ctrl = this;

    if (ctrl.vehicle && ctrl.vehicle.vehicleId) {
      let editPriceValues = ctrl.vehicle.priceValues;
      let newPriceValues = _map(ctrl.priceLookups, item => {
        const matchingPriceValue = _find(editPriceValues, o => o.priceLookupId === item.priceLookupId);
        const value = (matchingPriceValue && matchingPriceValue.value) ? matchingPriceValue.value : '';

        return {
          priceLookupId: item.priceLookupId,
          code: item.code,
          name: item.name,
          value: value
        }
      });

      ctrl.vehicle.priceValues = newPriceValues;
      ctrl.updateVehiclePrice();
  }
}

  initializeLookups() {
    const ctrl = this;

    this.lookupService.lookupPriceLookups(this.authService.authData.currentLocation.key)
      .then(priceLookups => {
        ctrl.priceLookups = priceLookups;

        this.vehicle.priceValues = _map(ctrl.priceLookups, item => {
          /*
          * 849
          * This is to ensure that the price values dont get wiped off
          * if for latency this block of code runs late
          */
          const pv = _find(this.vehicle.priceValues, o => o.priceLookupId === item.priceLookupId);
          const value = (pv != null && pv.value) ? pv.value : '';

          return {
            priceLookupId: item.priceLookupId,
            code: item.code,
            name: item.name,
            value: value
          }
        });
      });
  }

  initializeEntityPriceFormula() {
    const ctrl = this;

    ctrl.priceManagementService.getPriceFormula(ctrl.authService.authData.currentLocation.key)
      .then(response => {
        ctrl.priceFormula = response.data;
        ctrl.formulaCalculation = '';
      });
  }

  updateVehiclePrice() {
    if (!this.priceFormula) {return ;}

    const ctrl = this;
    const pattern = new RegExp(/{(\w*?)}/g);
    let matches;
    let temp = ctrl.priceFormula.toUpperCase();
    let priceLookup;

    while (matches = pattern.exec(ctrl.priceFormula.toUpperCase())) {
      priceLookup = _find(ctrl.vehicle.priceValues, o => o.code === matches[1]);
      if (priceLookup && priceLookup.value) {
        temp = temp.replace(matches[0], priceLookup.value);
      }
      else {
        temp = temp.replace(matches[0], 0);
      }
    }

    try {
      ctrl.formulaCalculation = temp;
      ctrl.vehicle.price = eval(temp);
    }
    catch(e){
      ctrl.vehicle.price = 0;
    }

  }
}

export default VehiclePricingController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehiclePricing/vehiclePricing.controller.js